<template>
  <div class="company-header">
    <div class="logo-empresa" data-nosnippet>
      <img loading="eager" fetchpriority="high" class="shadow-sm" :class="{'bg-primary': !empresa.url_imagem}" :src="empresa.url_imagem || fallback" :alt="empresa.nome_fantasia">
      <div class="badge-empresa small mb-1" v-if="showStatus">
        <span class="badge badge-success" v-if="empresa.ativo === '1' && empresa.aberto === '1'">ABERTO</span>
        <span class="badge badge-dark" v-else-if="empresa.empresaAberta">AGENDAMENTO</span>
        <span class="badge badge-danger" v-else>FECHADO</span>
      </div>
    </div>
    <div class="info-empresa">
      <component :is="headingTag" class="h4 font-weight-bold mb-0" :class="{'limite': truncateName}" :style="truncateName ? {maxHeight: '56px'} : null">{{empresa.nome_fantasia}}</component>
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CompanyHeader',
  props: {
    empresa: {type: Object, required: true},
    fallback: {type: String, required: true},
    showStatus: {type: Boolean, default: true},
    headingTag: {type: String, default: 'h1'},
    truncateName: {type: Boolean, default: false}
  }
}
</script>

<style scoped>
.company-header {
  display: flex;
  align-items: center;
  margin-top: -22px;
  position: relative;
  z-index: 2;
}
  .logo-empresa {
    width: 115px;
    height: 115px;
    background-color: #F4F5F7;
    border: 6px solid #F4F5F7;
    border-radius: 50%;
    position: relative;
    flex: 0 0 115px;
    margin: 0 6px 0 -6px;
  }

  .logo-empresa img {
    border-radius: 50%;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .badge-empresa {
    position: absolute;
    z-index: 1;
    left: 50%;
    transform: translateX(-50%);
    bottom: -9px;
  }

  .badge-empresa .badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: 1.25;
    padding: 0.125em 0.4em;
    vertical-align: middle;
    border: 1px solid #ffffff;
    border-radius: 8px;
  }

  .info-empresa {
    min-width: 0;
    overflow-wrap: anywhere;
    padding-top: 26px;
  }

@media (min-width: 768px) {
  .logo-empresa {
    flex-basis: 120px;
    width: 120px;
    height: 120px;
  }
}
</style>
